import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ImageUploader from '../../components/admin/ImageUploader';

// YÖNETİLEBİLİR KATALOG SAYFASI TİPLERİ
export type CatalogPageType = 'cover' | 'inner-text' | 'image' | 'back-cover';

export interface CatalogPageData {
  id: string;
  type: CatalogPageType;
  
  // Görsel Sayfalar (image) için
  imageUrl?: string;
  imageTitle?: string;
  imageSubtitle?: string;
  imageTextAlign?: 'left' | 'right';
  
  // Metin / Kurumsal Sayfalar (inner-text) için
  textSubtitle?: string;
  textTitle?: string;
  textContent?: string;
  isDark?: boolean;
}

const initialCatalogPages: CatalogPageData[] = [
  { id: 'page-1', type: 'cover' },
  { id: 'page-2', type: 'inner-text', textSubtitle: 'VİZYONUMUZ', textTitle: 'Geleceğin Güvenli \n Yaşam Alanları', textContent: 'KARE YAPI olarak, sadece binalar değil; içinde mutlulukların yeşereceği, güvenli, estetik ve modern yaşam alanları inşa ediyoruz.\n\nKaliteyi lüks olmaktan çıkarıp erişilebilir standart haline getiriyoruz.' },
  { id: 'page-3', type: 'image', imageUrl: '/premium-project-block.png', imageTitle: 'Prestij Serisi', imageSubtitle: 'KARE MODERN & REZİDANS', imageTextAlign: 'left' },
  { id: 'page-4', type: 'inner-text', textSubtitle: 'MÜHENDİSLİK', textTitle: 'Tavizsiz Yapı Güvenliği', textContent: 'Türkiye\'nin sismik risklerine karşı KARE YAPI olarak "sıfır tolerans" prensibiyle çalışıyoruz. C35 üstü yüksek dayanımlı beton, ileri hesaplama ve sıkı denetim.\n• İleri Deprem Mühendisliği\n• Kurumsal Kentsel Dönüşüm' },
  { id: 'page-5', type: 'image', imageUrl: '/tk-const-new-1.png', imageTitle: 'Aktif İmalat', imageSubtitle: 'C35 Beton ve Sağlam Karkas', imageTextAlign: 'right' },
  { id: 'page-6', type: 'inner-text', textSubtitle: 'Site Projeleri', textTitle: 'Örnek Premium Siteler', textContent: 'Modern çizgilere sahip 8 katlı blok konseptlerimizle yeni nesil aile yaşam standartlarını belirliyoruz. Ferah peyzaj, 7/24 güvenlik ve yeşil alanlar.' },
  { id: 'page-7', type: 'image', imageUrl: '/yapsat-site-7.png', imageTitle: 'Estetik Cepheler', imageSubtitle: 'Ahşap ve Beyazın Uyumu', imageTextAlign: 'right' },
  { id: 'page-8', type: 'image', imageUrl: '/yapsat-site-8.png', imageTitle: 'Köşe Blok Tasarımı', imageSubtitle: 'KARE YAPI Site Konsepti', imageTextAlign: 'left' },
  { id: 'page-9', type: 'image', imageUrl: '/yapsat-site-9.png', imageTitle: 'Huzurlu Yaşam', imageSubtitle: 'Günün Her Saati Güzellik', imageTextAlign: 'right' },
  { id: 'page-10', type: 'inner-text', textSubtitle: 'Kentsel Dönüşüm', textTitle: 'Butik ve Modern Apartmanlar', textContent: 'Eski binaları yıkıp yerlerine kentsel dokuya uyum sağlayan, göz hizasında (5-7 katlı) elit, ultra lüks butik projeler inşa ediyoruz. Şehrin merkezinde kalite arayanlar için.' },
  { id: 'page-11', type: 'image', imageUrl: '/yapsat-realistic-1.png', imageTitle: 'Kentsel Dönüşüm', imageSubtitle: '6 Katlı Modern Apartman', imageTextAlign: 'right' },
  { id: 'page-12', type: 'image', imageUrl: '/yapsat-realistic-2.png', imageTitle: 'Köşe Başı Prestij Konut', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-13', type: 'image', imageUrl: '/yapsat-realistic-3.png', imageTitle: '5 Katlı Butik Rezidans', imageSubtitle: '', imageTextAlign: 'right' },
  { id: 'page-14', type: 'image', imageUrl: '/premium-project-v3.png', imageTitle: 'İkizler Sitesi', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-15', type: 'image', imageUrl: '/premium-project-v4.png', imageTitle: 'Butik Konaklar', imageSubtitle: '', imageTextAlign: 'right' },
  { id: 'page-16', type: 'inner-text', isDark: true, textSubtitle: 'Ortak Alanlar', textTitle: 'Eksiksiz Sosyal Donatılar', textContent: 'Projelerimizde yaşam kalitesini artıracak detaylara önem veriyoruz. Çocuk oyun alanları, kapalı otopark çözümleri ve fitness merkezleriyle tam teşekküllü siteler yaratıyoruz.' },
  { id: 'page-17', type: 'image', imageUrl: '/yapsat-common-1.png', imageTitle: 'Site İçi Nizami Açık Otopark', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-18', type: 'image', imageUrl: '/yapsat-common-2.png', imageTitle: 'Modern Fitness Salonları', imageSubtitle: '', imageTextAlign: 'right' },
  { id: 'page-19', type: 'image', imageUrl: '/yapsat-common-3.png', imageTitle: 'Bina Altı Araç Parkları', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-20', type: 'image', imageUrl: '/yapsat-common-4.png', imageTitle: 'Güvenli Çocuk Parkları', imageSubtitle: 'Kauçuk Zemin Güvenliği', imageTextAlign: 'right' },
  { id: 'page-21', type: 'inner-text', textSubtitle: 'İç Mimari', textTitle: 'Ödüllü Yaşam Alanları Tasarımları', textContent: 'Avrupa standartlarında ankastre mutfaklar, akıllı ev otomasyon altyapısı, 1. sınıf parke ve seramik kaplamalarla sadece lüks değil, sıcak bir yuva kuruyoruz.' },
  { id: 'page-22', type: 'image', imageUrl: '/tk-int-ref-1.png', imageTitle: 'Geniş ve Aydınlık Mutfaklar', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-23', type: 'image', imageUrl: '/tk-int-1.png', imageTitle: 'Prestijli Salonlar', imageSubtitle: '', imageTextAlign: 'right' },
  { id: 'page-24', type: 'image', imageUrl: '/tk-int-9.png', imageTitle: 'Modern Donanımlı Banyolar', imageSubtitle: '1. Sınıf Armatür Sistemleri', imageTextAlign: 'left' },
  { id: 'page-24-1', type: 'image', imageUrl: '/tk-int-4.png', imageTitle: 'Estetik Detaylar', imageSubtitle: 'Modern İç Mimari', imageTextAlign: 'right' },
  { id: 'page-24-2', type: 'image', imageUrl: '/tk-int-5.png', imageTitle: 'Ferah Yaşam Alanları', imageSubtitle: 'Aydınlık ve Kullanışlı', imageTextAlign: 'left' },
  { id: 'page-24-3', type: 'image', imageUrl: '/tk-int-6.png', imageTitle: 'Şık ve Konforlu', imageSubtitle: 'Özel Tasarım Mobilyalar', imageTextAlign: 'right' },
  { id: 'page-24-4', type: 'image', imageUrl: '/tk-int-8.png', imageTitle: 'Konforlu Odalar', imageSubtitle: 'Huzur Veren Tasarım', imageTextAlign: 'left' },
  { id: 'page-24-5', type: 'image', imageUrl: '/tk-int-10.png', imageTitle: 'Lüks Ebeveyn Banyoları', imageSubtitle: 'Özel Kullanım Alanı', imageTextAlign: 'right' },
  { id: 'page-24-6', type: 'image', imageUrl: '/tk-int-11.png', imageTitle: 'Modern Giyinme Odaları', imageSubtitle: 'Kullanışlı Tasarım', imageTextAlign: 'left' },
  { id: 'page-24-7', type: 'image', imageUrl: '/tk-int-12.png', imageTitle: 'Geniş Hol ve Koridor', imageSubtitle: 'Ferah Geçiş Alanları', imageTextAlign: 'right' },
  { id: 'page-24-8', type: 'image', imageUrl: '/yapsat-int-1.png', imageTitle: 'Şık Salon Konsepti', imageSubtitle: 'Modern Mimari', imageTextAlign: 'left' },
  { id: 'page-24-9', type: 'image', imageUrl: '/yapsat-int-2.png', imageTitle: 'Kullanışlı Mutfaklar', imageSubtitle: 'Ankastre Donanım', imageTextAlign: 'right' },
  { id: 'page-24-10', type: 'image', imageUrl: '/yapsat-int-3.png', imageTitle: 'Aydınlık Yatak Odaları', imageSubtitle: 'Huzurlu Dinlenme Alanı', imageTextAlign: 'left' },
  { id: 'page-24-11', type: 'image', imageUrl: '/yapsat-int-4.png', imageTitle: 'Modern Banyo Tasarımı', imageSubtitle: 'Kaliteli Malzeme', imageTextAlign: 'right' },
  { id: 'page-25', type: 'image', imageUrl: '/tk-const-new-2.png', imageTitle: 'Aktif Şantiyeler', imageSubtitle: 'Zamanında Teslim Garantisi', imageTextAlign: 'right' },
  { id: 'page-26', type: 'image', imageUrl: '/tk-const-new-3.png', imageTitle: 'İnce İşçilik ve Dış Cephe', imageSubtitle: '', imageTextAlign: 'left' },
  { id: 'page-27', type: 'image', imageUrl: '/tk-const-4.png', imageTitle: 'Büyük Ekip, Büyük Hedef', imageSubtitle: 'Sürekli Gelişen Büyüyen Kadro', imageTextAlign: 'right' },
  { id: 'page-28', type: 'image', imageUrl: '/premium-project-v6.png', imageTitle: 'KARE MODERN Serisi', imageSubtitle: 'Geniş Bahçeli Teraslar', imageTextAlign: 'left' },
  { id: 'page-29', type: 'image', imageUrl: '/premium-project-v7.png', imageTitle: 'Avangart Mimari', imageSubtitle: 'Geleceğin Çizgileri', imageTextAlign: 'right' },
  { id: 'page-30', type: 'image', imageUrl: '/premium-project-v8.png', imageTitle: 'Şehirde Loft Yaşam', imageSubtitle: 'Geniş ve Açık Alanlar', imageTextAlign: 'left' },
  { id: 'page-31', type: 'image', imageUrl: '/premium-project-v9.png', imageTitle: 'Prestij Kulesi', imageSubtitle: 'Benzersiz Kristal Cephe', imageTextAlign: 'right' },
  { id: 'page-32', type: 'image', imageUrl: '/premium-project-v10.png', imageTitle: 'Modern İkiz Park', imageSubtitle: 'Yeşille Bütünleşen Bloklar', imageTextAlign: 'left' },
  { id: 'page-33', type: 'image', imageUrl: '/yapsat-site-6.png', imageTitle: 'Şehrin İçinde', imageSubtitle: 'Sıcak Sokak Perspektifleri', imageTextAlign: 'right' },
  { id: 'page-34', type: 'back-cover' }
];

export default function CatalogManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  
  const [pages, setPages] = useState<CatalogPageData[]>(initialCatalogPages);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'pages', 'catalog');
        const snap = await getDoc(docRef);
        if (snap.exists() && snap.data().items && snap.data().items.length > 0) {
          // Identify unrepresented native elements that were injected into the seed code later on
          const existingIds = snap.data().items.map((i: any) => i.id);
          const injectedOrMissingElements = initialCatalogPages.filter(i => !existingIds.includes(i.id));

          // Retain live values while validating constraints logic
          const dbItems = snap.data().items.map((dbPage: any) => {
             const defItem = initialCatalogPages.find(i => i.id === dbPage.id);
             return {
                ...dbPage,
                imageUrl: dbPage.imageUrl || defItem?.imageUrl || ''
             }
          });
          
          let validatedMatrix = dbItems;
          
          if (injectedOrMissingElements.length > 0) {
              validatedMatrix = initialCatalogPages.map(initialItem => {
                 const existingItem = dbItems.find((dbI: any) => dbI.id === initialItem.id);
                 return existingItem ? existingItem : initialItem;
              });
              
              await setDoc(docRef, { items: validatedMatrix, updatedAt: new Date() }, { merge: true });
          } else {
              // Standard overwrite patch to enforce structural normalization
              await setDoc(docRef, { items: validatedMatrix, updatedAt: new Date() }, { merge: true });
          }
          
          setPages(validatedMatrix);
        } else {
          // Migration
          await setDoc(docRef, { items: initialCatalogPages, updatedAt: new Date() }, { merge: true });
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (id: string, field: string, value: any) => {
    setPages(pages.map(p => p.id === id ? { ...p, [field]: value } : p));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const docRef = doc(db, 'pages', 'catalog');
      await setDoc(docRef, { items: pages, updatedAt: new Date() }, { merge: true });
      setMessage('Katalog başarıyla güncellendi, canlı sitede yayında!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error(err);
      setMessage('Kayıt başarısız oldu.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-zinc-500">Katalog Yükleniyor...</div>;

  return (
    <div className="space-y-6 pb-24">
      <div className="mb-6">
        <h2 className="text-2xl font-black text-white uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>3D Katalog Sayfa Yöneticisi</h2>
        <p className="text-zinc-400 text-sm mt-1">Sitedeki 34 sayfalık e-kataloğun her bir sayfasındaki görselleri ve yazıları buradan tek tek yönetebilirsiniz.</p>
      </div>

      {message && (
        <div className={`p-4 rounded-xl font-bold text-sm ${message.includes('başarısız') ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
          {message}
        </div>
      )}

      <div className="space-y-8">
        {pages.map((p, index) => {
          if (p.type === 'cover' || p.type === 'back-cover') return null; // We skip editing covers for safety of the UI

          return (
            <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8">
              <div className="flex items-center gap-3 mb-6 border-b border-zinc-800 pb-4">
                <div className="w-8 h-8 rounded-full bg-red-600/10 text-red-500 font-bold flex items-center justify-center">{index + 1}</div>
                <h3 className="text-lg font-bold text-white uppercase tracking-wider">
                  SAYFA {index + 1} - {p.type === 'image' ? 'Tam Ekran Görsel & Başlık' : 'Kurumsal Yazı Sayfası'}
                </h3>
              </div>

              {p.type === 'image' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Ana Başlık (Beyaz, Büyük)</label>
                      <input type="text" value={p.imageTitle || ''} onChange={e => handleChange(p.id, 'imageTitle', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
                    </div>
                    <div>
                      <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Alt Başlık (Silik Yazı)</label>
                      <input type="text" value={p.imageSubtitle || ''} onChange={e => handleChange(p.id, 'imageSubtitle', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Yazının Konumu</label>
                    <select value={p.imageTextAlign} onChange={e => handleChange(p.id, 'imageTextAlign', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none appearance-none">
                      <option value="left">Sol Köşe</option>
                      <option value="right">Sağ Köşe</option>
                    </select>
                  </div>
                  <div className="pt-2 border-t border-zinc-800/50">
                    <ImageUploader 
                      currentImageUrl={p.imageUrl || ''} 
                      onImageUploaded={(url) => handleChange(p.id, 'imageUrl', url)} 
                      onImageDeleted={() => handleChange(p.id, 'imageUrl', '')} 
                      folderPath={`pages/catalog/page_${index+1}`}
                      label="Sayfayı Kaplayacak Görsel"
                    />
                  </div>
                </div>
              )}

              {p.type === 'inner-text' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Üst Madde (Küçük, Renkli)</label>
                      <input type="text" value={p.textSubtitle || ''} onChange={e => handleChange(p.id, 'textSubtitle', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
                    </div>
                    <div>
                      <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Büyük Ana Başlık (\n ile satır atlatabilirsiniz)</label>
                      <input type="text" value={p.textTitle || ''} onChange={e => handleChange(p.id, 'textTitle', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Uzun Paragraf Metni (Satır atlamak için Enter kullanın)</label>
                    <textarea value={p.textContent || ''} onChange={e => handleChange(p.id, 'textContent', e.target.value)} rows={5} className="w-full bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"></textarea>
                  </div>
                </div>
              )}

            </motion.div>
          );
        })}
      </div>

      <div className="fixed bottom-0 left-0 right-0 md:left-64 bg-zinc-950/80 backdrop-blur-lg border-t border-zinc-800 p-4 flex justify-end z-50">
         <button onClick={handleSave} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white font-black text-lg py-4 px-12 rounded-xl shadow-2xl shadow-red-600/30 transition-all flex items-center gap-3 disabled:opacity-50">
           {saving ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-save-3-line"></i>}
           TÜM KATALOĞU KAYDET
         </button>
      </div>
    </div>
  );
}
